import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const OrgIdContext = createContext<number | null>(null);

// Define the mapping from the path param to actual orgId (using UUID)
const pathToOrgIdMap: Record<string, number> = {
  "48c6dbca-44eb-4cba-90af-8ea005fb2038": 9,
  "d4d7640a-cfc4-40fe-8e00-4ff07c5d6b48": 52,
  "9148f998-7800-474b-becc-7c81994fa9c5": 12,
  "a6c0adb0-6af8-4332-b88b-7faf0c6b2da9": 5000,
  "403f70d2-fd0a-4328-9b95-734ca733823a": 5001,
  "90dad203-e5a6-40b4-a9ee-2888d2131162": 10
};

export const OrgIdProvider = ({ children }: { children: React.ReactNode }) => {
  const [orgId, setOrgId] = useState<number | null>(null);
  const location = useLocation();

  useEffect(() => {
    // Extract path segments
    const pathSegments = location.pathname.split("/").filter(Boolean);
    
    // If there is a UUID in the path, use that
    const pathUuid = pathSegments.length > 0 ? pathSegments[0] : null;

    console.log('path uuid:', pathUuid);

    // Get orgId from mapping based on UUID, or default to 9
    setOrgId(pathUuid && pathToOrgIdMap[pathUuid] ? pathToOrgIdMap[pathUuid] : 9);
  }, [location.pathname]);

  return <OrgIdContext.Provider value={orgId}>{children}</OrgIdContext.Provider>;
};

export const useOrgId = () => useContext(OrgIdContext);